/**
 * Returnerer relativ URL for bruk med react-router <Link />
 * @param absoluteUrl Komplett URL til en samvalgsside, f.eks. https://tjenester-hn-mas-01.int-hn.nhn.no/samvalg/graves-sykdom/kirurgi
 * @returns Relativ URL
 */
export const getRelativePath = (absoluteUrl: string): string => {
  const pathname = new URL(absoluteUrl).pathname;
  const queryString = new URL(absoluteUrl).search;

  return '/' + pathname.split('/').splice(2).join('/') + queryString;
};
